import { useState } from 'react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const orgTypes = ['Venture Capital Firm', 'Accelerator', 'Community Organization', 'Fellowship / Cohort Program', 'Other'];
const seatRanges = ['1–5', '6–10', '11–25', '25+'];

export const InstitutionalIntakeForm = ({ preSelectedOrgType = '' }) => {
  const [form, setForm] = useState({ name: '', title: '', orgName: '', orgType: preSelectedOrgType, seatCount: '', inquiry: '', heardFrom: '' });
  const [submitted, setSubmitted] = useState(false);

  const upd = (f, v) => setForm(p => ({ ...p, [f]: v }));
  const ic = `w-full px-5 py-3.5 bg-white/50 border border-vine-neutral/20 text-vine-primary text-[15px] placeholder:text-vine-neutral/35 focus:outline-none focus:border-copper/50 focus:ring-1 focus:ring-copper/20 transition-colors`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.orgName.trim() || !form.orgType) {
      toast.error('Please complete the required fields.');
      return;
    }
    try {
      await axios.post(`${API}/applications`, { ...form, applicationType: 'institutional', orgType: form.orgType });
      setSubmitted(true);
    } catch { toast.error('Something went wrong. Please try again.'); }
  };

  if (submitted) return (
    <div className="py-12">
      <p className="font-display text-2xl text-vine-primary font-light mb-4">Inquiry received.</p>
      <p className="text-vine-primary/55 text-[15px]">We'll follow up within 3 business days.</p>
    </div>
  );

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div><label className="text-[13px] text-vine-primary/60 tracking-wide block mb-2">Your name *</label><input type="text" value={form.name} onChange={e => upd('name', e.target.value)} className={ic} /></div>
      <div><label className="text-[13px] text-vine-primary/60 tracking-wide block mb-2">Your title</label><input type="text" value={form.title} onChange={e => upd('title', e.target.value)} className={ic} /></div>
      <div><label className="text-[13px] text-vine-primary/60 tracking-wide block mb-2">Organization name *</label><input type="text" value={form.orgName} onChange={e => upd('orgName', e.target.value)} className={ic} /></div>
      <div><label className="text-[13px] text-vine-primary/60 tracking-wide block mb-2">Organization type *</label>
        <select value={form.orgType} onChange={e => upd('orgType', e.target.value)} className={`${ic} appearance-none cursor-pointer`}>
          <option value="">Select type</option>{orgTypes.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>
      <div><label className="text-[13px] text-vine-primary/60 tracking-wide block mb-2">Number of founders / members / fellows considered</label>
        <select value={form.seatCount} onChange={e => upd('seatCount', e.target.value)} className={`${ic} appearance-none cursor-pointer`}>
          <option value="">Select range</option>{seatRanges.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <div><label className="text-[13px] text-vine-primary/60 tracking-wide block mb-2">What's driving this inquiry?</label><textarea rows={3} value={form.inquiry} onChange={e => upd('inquiry', e.target.value)} className={`${ic} resize-none leading-relaxed`} /></div>
      <div><label className="text-[13px] text-vine-primary/60 tracking-wide block mb-2">How did you hear about the Advisory Circle?</label><input type="text" value={form.heardFrom} onChange={e => upd('heardFrom', e.target.value)} className={ic} /></div>
      <button type="submit" className="px-10 py-3.5 bg-copper text-white text-[13px] tracking-[0.1em] uppercase btn-copper">Send Inquiry</button>
      <p className="text-vine-primary/30 text-[12px]">This form is for institutional inquiries only. <a href="/apply" className="text-copper/60 hover:text-copper">Individual applications go here &rarr;</a></p>
    </form>
  );
};
